<div class="modal-header">
  <h4 class="modal-title">Групово обновяване</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()">
  </button>
</div>
<div class="modal-body">
  <section class="mb-4 alert bg-primary-subtle">
    <p>
      При обновяване на обява се задава нова крайна дата, до която искате обявата да бъде активна. Останалата информация
      ще се запази без промяна.
    </p>
    <p class="m-0">
      Можете да обновите избрани обяви или да изберете всички.
    </p>
  </section>
  @if (!loadingData) {
    @if (renewableAds.length === 0) {
      <h5 class="my-5 text-muted text-center">Няма завършили обяви без сделка, които могат да бъдат обновени.</h5>
    } @else {
      <form [formGroup]="form">
        <div class="mb-3 row g-4">
          <div class="col-12 col-md-6">
            <label for="endDate" class="mb-0 form-label">Крайна дата и час*</label>
            <div class="input-group">
              <input
                ngbDatepicker
                id="endDate"
                name="endDate"
                formControlName="endDate"
                #endDatepicker="ngbDatepicker"
                placeholder="Изберете дата (дд.мм.гггг)"
                [minDate]="endDateMinDate"
                [maxDate]="endDateMaxDate"
                class="form-control rounded-start-1"
                [class.border-success]="endDate?.touched && endDate?.valid"
                [class.border-danger]="endDate?.touched && endDate?.invalid"/>
              <button
                type="button"
                [disabled]="endDatepicker.disabled"
                class="btn btn-outline-secondary"
                (click)="endDatepicker.toggle()">
                <i class="fa-regular fa-calendar-days"></i>
              </button>
            </div>
            @if (endDate?.touched && endDate?.invalid) {
              <small class="text-danger">Задължително поле във формат дд.мм.гггг!</small>
            }
          </div>
          <div class="col-6 col-md-3">
            <span class="form-label">Час*</span>
            <ng-select
              [clearable]="false"
              [searchable]="false"
              [items]="hourOptions"
              bindValue="value"
              bindLabel="label"
              formControlName="endHour"
              notFoundText="Няма намерени часове"
              placeholder="Изберете час"
              [class.is-valid]="endHour?.touched && endHour?.valid"
              [class.is-invalid]="endHour?.touched && endHour?.invalid">
            </ng-select>
            @if (endHour?.touched && endHour?.invalid) {
              <p class="m-0 invalid-feedback">Задължително поле!</p>
            }
          </div>
          <div class="col-6 col-md-3">
            <span class="form-label">Минути*</span>
            <ng-select
              [clearable]="false"
              [searchable]="false"
              [items]="minutesOptions"
              bindValue="value"
              bindLabel="label"
              formControlName="endMinutes"
              notFoundText="Няма намерени минути"
              placeholder="Изберете минути"
              [class.is-valid]="endMinutes?.touched && endMinutes?.valid"
              [class.is-invalid]="endMinutes?.touched && endMinutes?.invalid">
            </ng-select>
            @if (endMinutes?.touched && endMinutes?.invalid) {
              <p class="m-0 invalid-feedback">Задължително поле!</p>
            }
          </div>
        </div>
      </form>
      <div class="mb-2 mt-4 d-flex align-items-center">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            id="select-all"
            [checked]="areAllSelected()"
            (change)="toggleSelectAll($event)">
          <label for="select-all" class="form-check-label">
            Изберете всички
          </label>
        </div>
      </div>
      <ul class="list-unstyled">
        @for (renewableAd of renewableAds; track renewableAd.adId) {
          <li
            class="mb-2 d-flex bg-light border rounded-3 align-items-center cursor-pointer"
            (click)="toggleAdSelection(renewableAd.adId)">
            <div class="form-check m-2">
              <input
                class="form-check-input"
                type="checkbox"
                id="checkbox-{{ renewableAd.adId }}"
                [checked]="selectedAdIds.includes(renewableAd.adId)">
            </div>
            <div class="card-image">
              <nz-image [imageUrl]="environment.apiImageAdUrl + '/main/' + renewableAd.adId"></nz-image>
            </div>
            <div class="p-2 text-primary-emphasis">
              <div>
                {{ renewableAd.title }}
              </div>
              <small class="text-muted">Обновявания: {{ renewableAd.renewalAfterExpirationCount }}</small>
            </div>
          </li>
        }
      </ul>
    }
  } @else {
    <div>
      <div class="text-center">
        <h3>
          <i class="text-muted fa-solid fa-spinner fa-spin"></i>
        </h3>
        <h5 class="text-muted">Зареждане...</h5>
      </div>
    </div>
  }
</div>
<div class="modal-footer d-block text-end">
  @if (formInvalidError && form.invalid) {
    <div class="text-start text-danger">
      Изберете валидна крайна дата и час.
    </div>
  }
  @if (notSelectedAdsError && selectedAdIds.length === 0) {
    <div class="text-start text-danger">
      Изберете поне една обява, която да бъде обновена.
    </div>
  }
  <button
    type="button"
    class="me-2 btn btn-outline-secondary"
    (click)="closeModal()">
    <span>Затвори</span>
  </button>
  <button
    type="button"
    [disabled]="loadingSubmit || renewableAds.length === 0"
    class="btn btn-nz-primary"
    (click)="onSubmit()">
    @if (loadingSubmit) {
      <span class="me-2 spinner-border spinner-border-sm"></span>
    }
    <span>Обнови</span>
  </button>
</div>
